import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedSlot.errors.";

const calendarSlotSortTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "calendar_slot_sort_type" }
);
const ticketAutomationReceivedSlotCalendarSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedSlotCalendars",
  }
);
export const automationReceivedSlotSchema = z.object({
  id: z.string().optional(),
  calendarSlotSortType: calendarSlotSortTypeSchema,
  slotsAvailable: z.string().min(1, translationPath + "slots_available"),
  priority: z.string().min(1, translationPath + "priority"),
  enable: z.boolean(),
  ticketAutomationReceivedSlotCalendars: z
    .array(ticketAutomationReceivedSlotCalendarSchema)
    .nullish(),
});

export type TAutomationReceivedSlotForm = z.infer<
  typeof automationReceivedSlotSchema
>;
